import { render, staticRenderFns } from "./ofd_mr.vue?vue&type=template&id=86ac8c72"
import script from "./ofd_mr.vue?vue&type=script&lang=js"
export * from "./ofd_mr.vue?vue&type=script&lang=js"
import style0 from "./ofd_mr.vue?vue&type=style&index=0&id=86ac8c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports